// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2FvFF","itemTitle":"ClientEmergencyInfo_itemTitle__dR6IH","itemText":"ClientEmergencyInfo_itemText__1Zzv7"};